// Human-readable file size from a raw byte count. Picks the largest unit that
// keeps the number ≥ 1 (so 512 → "512 B", 1536 → "1.5 KB", 2_400_000 → "2.4 MB"),
// up to TB. Bytes render as whole numbers; larger units show one decimal with a
// trailing ".0" trimmed. App-wide helper — keep it dependency-free.
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
  const value = bytes / 1024 ** exponent;
  const formatted = exponent === 0 ? String(Math.round(value)) : value.toFixed(1).replace(/\.0$/, '');
  return `${formatted} ${UNITS[exponent]}`;
}
